module.exports = __webpack_public_path__ + "media/images/area/feature/common/icon_arrow_slide-ac6e1cc9366c7430e69df1b616ff4daa.svg";